import React from 'react';
import PropTypes from 'prop-types';
import RegistryCollectionHeader from './RegistryCollectionHeader';
import RegistryCollectionItemTile from './RegistryCollectionItemTile';

const RegistryGrid = ({ collection, collectionItems, onAddToCart, onShowProduct, enableCustomCollections }) => {
  if (collectionItems.length === 0) return null;

  return (
    <div className="row">
      {collection && <RegistryCollectionHeader collection={collection} enableCustomCollections={enableCustomCollections} count={collectionItems.length} />}
      {collectionItems.map(collectionItem => (
        <div key={collectionItem.object_id} className={`${window.optimizelyShowLargeGrid ? 'col-sm-4 col-xs-6' : 'col-lg-3 col-sm-4 col-xs-6'}`}>
          <RegistryCollectionItemTile
            collectionItem={collectionItem}
            onAddToCart={onAddToCart}
            onShowProduct={onShowProduct}
          />
        </div>
      ))}
    </div>
  );
};

RegistryGrid.propTypes = {
  collection: PropTypes.shape({}),
  collectionItems: PropTypes.arrayOf(PropTypes.shape({})),
  onAddToCart: PropTypes.func.isRequired,
  onShowProduct: PropTypes.func.isRequired,
  enableCustomCollections: PropTypes.bool
};

export default RegistryGrid;



/** WEBPACK FOOTER **
 ** ./src/components/registry/RegistryGrid.jsx
 **/